import { z } from 'zod';

/**
 * Email step of the creator invite OTP sign-up flow.
 * Email-only — the OTP itself is requested on submit, not collected here.
 */
export const inviteEmailSchema = z.object({
  email: z.string().min(1, 'Email is required').pipe(z.email('Please enter a valid email address')),
});

export type InviteEmailFormData = z.infer<typeof inviteEmailSchema>;
